import { Person } from '@mui/icons-material';
import { AvatarProps } from '@mui/material';
import { useMemo } from 'react';
import { Union } from 'ts-toolbelt';

import { initials } from '~/util/string';

import { AvatarStyled } from './UserAvatar.styled';

export interface UserAvatarProps extends Omit<AvatarProps, 'children'> {
  user?: {
    firstName?: Union.Nullable<string>;
    lastName?: Union.Nullable<string>;
    pictureId?: Union.Nullable<string>;
  };
}

export const UserAvatar = ({ user, ...otherProps }: UserAvatarProps) => {
  const firstName = user?.firstName;
  const lastName = user?.lastName;
  const nameInitials = useMemo(() => {
    return initials([firstName, lastName]);
  }, [firstName, lastName]);

  return (
    <AvatarStyled {...otherProps} imageId={user?.pictureId ?? undefined}>
      {nameInitials || <Person />}
    </AvatarStyled>
  );
};
